import React, {Component} from 'react';

import Button from '@material-ui/core/Button/index';
import TextField from '@material-ui/core/TextField/index';
import Dialog from '@material-ui/core/Dialog/index';
import DialogActions from '@material-ui/core/DialogActions/index';
import DialogContent from '@material-ui/core/DialogContent/index';
import DialogTitle from '@material-ui/core/DialogTitle/index';
import FormControlLabel from "@material-ui/core/FormControlLabel/index";
import Checkbox from "@material-ui/core/Checkbox/index";
import FormGroup from "@material-ui/core/FormGroup/index";
import Slide from "@material-ui/core/Slide/index";
import DraggableModal from "../../../../Include/DraggableModal/DraggableModal";

class ModalEjecutivoAsignado extends Component {
	
	render() {
		
		return (
			<div>
				
				<Dialog open={this.props.modal.open} onClose={() => this.props.closeModal()} disableEscapeKeyDown
				        disableBackdropClick maxWidth={'sm'} fullWidth={true} scroll={'paper'}
				        transition={<Slide direction="up"/>} aria-labelledby="scroll-dialog-title"
				        PaperComponent={DraggableModal}
				>
					
					<DialogTitle>
						{this.props.modal.title} ejecutivo asignado a tesorería
					</DialogTitle>
					
					<DialogContent>
						
						<article>
							
							<TextField
								required
								className={'margin-0'}
								select
								fullWidth
								margin="dense"
								onChange={this.props.handleChange}
								disabled={this.props.modal.tipo === 'view' || this.props.modal.tipo === 'edit'}
								SelectProps={{
									native: true,
									MenuProps: {
										className: '',
									},
								}}
								
								helperText=""
								name="id_usuario"
								label="Ejecutivo asignado a tesorería"
								value={this.props.form.id_usuario}
							>
								<option key={0} value={''}>&nbsp;</option>
								{this.props.cat_usuario_ejecutivo.map(option => (
									<option key={option.id_usuario} value={option.id_usuario}>
										{option.nombre} {option.apellido_paterno} {option.apellido_materno}
									</option>
								))}
							</TextField>
							
							<TextField
								multiline
								margin="dense"
								name="descripcion"
								label="Descripción"
								type="text"
								fullWidth
								defaultValue={this.props.form.descripcion}
								onChange={this.props.handleChange}
								disabled={this.props.modal.tipo === 'view'}
							/>
							
							<FormGroup row className={'margin-3-L'}>
								<FormControlLabel
									control={
										<Checkbox type="checkbox" name='activo' checked={this.props.form.activo}
										          onChange={this.props.handleChange} value="activo" color="primary"
										          disabled={this.props.modal.tipo === 'view'}/>
									}
									label={'Activo'}
								/>
							</FormGroup>
						
						</article>
					
					</DialogContent>
					
					<DialogActions>
						
						<Button onClick={() => this.props.closeModal()} color="primary">
							{this.props.modal.tipo === 'view' ? 'Cerrar' : 'Cancelar'}
						</Button>
						
						{this.props.modal.tipo !== 'view' ? (
							<Button onClick={() => this.props.save()} color="primary">
								{this.props.form.id_ejecutivo_asignado_tesoreria > 0 ? 'Actualizar' : 'Agregar'}
							</Button>
						) : ''}
					
					</DialogActions>
				
				</Dialog>
			
			
			</div>
		);
	}
}

export default ModalEjecutivoAsignado;
